module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAUCAYAAACXtf2DAAAASklEQVQ4je3TsRGAQAwDwX2GlP4rhAa+ANMBjkTkK+ACaW5V1Y1Lhr2qqkJycCTlcOIRniglByt8wT8fxCeaDj6ZDlqmg47poGW/4kcsnS3nyH8AAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/img/icons/menu-icon.png
// module id = 295
// module chunks = 0